/**
 * Parses a User-Agent string into OS, browser, and device type.
 */
export interface ClientInfo {
  os: string;
  browser: string;
  /** "Mobile" or "Desktop" */
  device: string;
  userAgent: string;
}

export function parseUserAgent(ua: string): ClientInfo {
  let browser = "Browser";
  if (/Edg\/|EdgA\/|EdgiOS\//.test(ua)) browser = "Edge";
  else if (/OPR\//.test(ua)) browser = "Opera";
  else if (/Chrome\//.test(ua) && !/Chromium/.test(ua)) browser = "Chrome";
  else if (/Firefox\//.test(ua)) browser = "Firefox";
  else if (/Safari\//.test(ua) && !/Chrome/.test(ua)) browser = "Safari";

  let os = "Unknown";
  if (/Windows/.test(ua)) os = "Windows";
  else if (/Android/.test(ua)) os = "Android";
  else if (/iPhone|iPad/.test(ua)) os = "iOS";
  else if (/Macintosh/.test(ua)) os = "macOS";
  else if (/Linux/.test(ua)) os = "Linux";

  const isMobile = /Android|iPhone|iPad|iPod|Mobile/.test(ua);
  const device = isMobile ? "Mobile" : "Desktop";

  return { os, browser, device, userAgent: ua };
}

/**
 * Returns parsed client info from the current browser's navigator.userAgent.
 * Returns sensible defaults when running server-side.
 */
let cachedClientInfo: ClientInfo | null = null;
export function getClientInfo(): ClientInfo {
  if (cachedClientInfo) return cachedClientInfo;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  cachedClientInfo = parseUserAgent(ua);
  return cachedClientInfo;
}
